/**
 * Triggers file download by emulating <a> tag click
 */
export function triggerDownloadViaLink(url, filename) {
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

/**
 * sets color-theme class on document root
 */
export function setColorTheme(mode = 'light') {
  const action = mode === 'light' ? 'remove' : 'add';
  document.body.classList[action]('theme-dark');
}
